import { JSONResolver } from "graphql-scalars";
export const JsonScalar = JSONResolver;
